import React from "react";

import "./email.scss";

function Email({ title = "Company Email" }) {
  return (
    <div className="Email">
      <p>{title}</p>
      <h1>{sessionStorage.getItem("mail")}</h1>
    </div>
  );
}

export default Email;
